module.exports = __webpack_public_path__ + "static/img/crm_detail.accda0c6.png";